export interface FaviconHrefs {
	prod: string;
	beta: string;
	stage: string;
}

export const DEFAULT_FAVICON_HREFS: FaviconHrefs = {
	prod: 'favicon.svg',
	beta: 'favicon-beta.svg',
	stage: 'favicon-stage.svg',
};

export function resolveFaviconHref(
	hostname: string,
	hrefs: FaviconHrefs = DEFAULT_FAVICON_HREFS
): string {
	const host = hostname.toLowerCase();
	if (host.includes('stage')) {
		return hrefs.stage;
	}
	if (host.includes('beta')) {
		return hrefs.beta;
	}
	return hrefs.prod;
}

export function applyEnvironmentFavicon(
	document: Document,
	hostname: string,
	hrefs: FaviconHrefs = DEFAULT_FAVICON_HREFS
): void {
	const href = resolveFaviconHref(hostname, hrefs);
	document.querySelector('link[rel="icon"]')?.remove();
	const link = document.createElement('link');
	link.rel = 'icon';
	link.type = 'image/svg+xml';
	link.href = href;
	document.head.appendChild(link);
}
